import React from "react";
import {
  createBrowserRouter,
  RouterProvider,
  Outlet,
  Navigate,
} from "react-router-dom";
import { AuthProvider } from "./AuthProvider";
import ProtectedRoute from "./ProtectedRoute";
import SupportFloatingButton from "./components/SupportFloatingButton";

import PaymentPage from "./pages/PaymentPage";
import LoginPage from "./pages/LoginPage";
import SignUpPage from "./pages/SignUpPage";
import BankInfoPage from "./pages/BankInfoPage";
import GameBetPage from "./pages/GameBetPage";
import DashboardPage from "./pages/DashboardPage";
import HistoryPage from "./pages/HistoryPage";
import LegalPage from "./pages/LegalPage";

const Layout = () => (
  <div>
    <Outlet />
    <SupportFloatingButton />
  </div>
);

export const router = createBrowserRouter([
  {
    path: "/",
    element: <Layout />,
    children: [
      {
        index: true, // root = "/" (authenticated dashboard)
        element: (
          <ProtectedRoute>
            <DashboardPage />
          </ProtectedRoute>
        ),
      },
      {
        path: "/payment",
        element: (
          <ProtectedRoute>
            <PaymentPage />
          </ProtectedRoute>
        ),
      },
      {
        path: "/history",
        element: (
          <ProtectedRoute>
            <HistoryPage />
          </ProtectedRoute>
        ),
      },
      {
        path: "/game/bet",
        element: (
          <ProtectedRoute>
            <GameBetPage />
          </ProtectedRoute>
        ),
      },
      { path: "/terms", element: <LegalPage /> },
      { path: "/privacy", element: <LegalPage /> },
      { path: "/login", element: <LoginPage /> },
      { path: "/sign-up", element: <SignUpPage /> },
      {
        path: "/bank-info/:transactionId",
        element: (
          <ProtectedRoute>
            <BankInfoPage />
          </ProtectedRoute>
        ),
      },
      // catch-all fallback
      { path: "*", element: <Navigate to="/" replace /> },
    ],
  },
]);

function AppRouter() {
  return (
    <AuthProvider>
      <RouterProvider router={router} />
    </AuthProvider>
  );
}

export default AppRouter;
